var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{style:({ marginTop: '2em' }),attrs:{"editable":false,"header":_vm.$t('common.notes')}},_vm._l((_vm.orderedNotes),function(note){return _c('note',{key:note.id,attrs:{"note":note}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }